import React from "react";
import "./Product.css";
import { useStateValue } from "./StateProvider";

function Product({ id, title, image, price, rating }) {
  const [, dispatch] = useStateValue(); // ignore state, use dispatch only

  const addToCart = () => {
    dispatch({
      type: "ADD_TO_CART",
      item: {
        id,
        title,
        image,
        price,
        rating,
      },
    });
  };

  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div className="product">
      <div className="product__info">
        <p>{title}</p>

        <p className="product__price">
          <span>$</span>
          <strong>{price}</strong>
        </p>

        <div className="product__rating">
          {[...Array(fullStars)].map((_, i) => (
            <p key={`full-${i}`}>⭐</p>
          ))}
          {hasHalfStar && <p key="half">🌓</p>}
          {[...Array(emptyStars)].map((_, i) => (
            <p key={`empty-${i}`}>☆</p>
          ))}
        </div>
      </div>

      <img src={image} alt={title} loading="lazy" />

      <button onClick={addToCart}>Add to Basket</button>
    </div>
  );
}

export default Product;
